import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from 'react';
import {Button, Space, Table, TablePaginationConfig} from 'antd';
import Icon from "./Icon";
import {fillZero, globalData} from "../util/util";
import {Link} from "react-router-dom";
import MatchInfo from "./page/MatchInfo";
import {useNavigate} from "react-router-dom";
import Svp from "./Svp";
import Mvp from "./Mvp";
import axios from "axios";
import LeftOutlined from "@ant-design/icons/lib/icons/LeftOutlined";
import SketchOutlined from "@ant-design/icons/lib/icons/SketchOutlined";
import SlackOutlined from "@ant-design/icons/lib/icons/SlackOutlined";

// const timeDiff = -480 - new Date().getTimezoneOffset()
const timeDiff = 0

export default (prop) => {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const [pageInfo, setPageInfo] = useState({
        current: 1,
        pageSize: 20,
        showSizeChanger: false,
    })
    const [data, setData] = useState([])
    const [game, setGame] = useState({})
    const [loading, setLoading] = useState(false)

    const fold = prop.playerHandle ||  prop.heroId ? true : false
    const [expand,setExpand] = useState(true)

    const columns2 = [
        {
            key: 'id',
            dataIndex: 'id',
            title: () =>
                <Space>
                    <Button onClick={() => setExpand(true)}>{<LeftOutlined />}</Button>
                    <Button onClick={() => {
                        axios.post(`game/mvp/0`, game).then(res => {
                            setGame(res)
                        })
                    }}>{<SlackOutlined />}</Button>
                    <Button onClick={() => {
                        axios.post(`game/mvp/1`, game).then(res => {
                            setGame(res)
                        })
                    }}>{<SketchOutlined />}</Button>
                </Space>
            ,
            render: (_, r) =>
            {
                const p = r.playerList.filter(p => p.playerHandle === prop.playerHandle || p.heroId == prop.heroId)
                    .sort((a, b) => a.playerHandle === prop.playerHandle ? -1 : 1)[0]

                return p && <Space>
                    <div style={{ position: 'relative' }}>
                        <Icon type={'hero'} name={p.heroId} size={42} />
                        {
                            p.mvp == 1 ?  <Mvp style={{ position: "absolute", bottom: 0, left: -2 }}/> : null
                        }
                        {
                            p.mvp == 2 ?  <Svp style={{ position: "absolute", bottom: 0, left: -2 }}/> : null
                        }

                    </div>

                    <Space direction={'vertical'} size={5}>
                        {
                            p.win == 0 ?
                                <span style={{color: "black"}} >{`${t('invalid')}(${p.kill}-${p.death}-${p.assist})`}</span> : p.win == 1 ?
                                <span style={{color: "rgb(102, 187, 106)"}} >{`${t('win')}(${p.kill}-${p.death}-${p.assist})`}</span>
                                :
                                <span style={{color: "rgb(255, 76, 76)"}} >{`${t('lose')}(${p.kill}-${p.death}-${p.assist})`}</span>}
                        <span>{new Date(Date.parse(r.endTime) + timeDiff * 60 * 1000).toLocaleDateString()}</span>
                    </Space>
                </Space> || <span>{new Date(Date.parse(r.endTime) + timeDiff * 60 * 1000).toLocaleDateString()}</span>

            }
            ,
            align: 'left',
        }
    ]

    const update = () => {
        setLoading(true)
        prop.update(pageInfo, (data) => {
            setPageInfo({...pageInfo})
            for (const item of data.filter(it => it.region === 3)) {

                item.endTime = new Date(item.id / 1000 - 9 * 3600 * 1000 + item.frame / 16 / 1.4 * 1000)
            }
            setData(data)
            setLoading(false)
        })
    }


    useEffect(() => {
        if (prop.heroId && prop.playerHandle) {
            globalData("playerHeroFlag", "1")
        } else {
            globalData("playerHeroFlag", "0")
        }
        setExpand(true)
        update()
    }, [prop.heroId, prop.playerHandle])

    pageInfo.onChange = (current, pageSize) => {
        pageInfo.current = current
        pageInfo.pageSize = pageSize
        setPageInfo({...pageInfo})
        update()
    }

    const GetModeName = (game) => {
        if (game.gameMode === 3) {
            return t('mode.competition')
        }
        return game.playerList.length === 1 && t('mode.single') || t(`mode.0_${game.mode}`) + t(`mode.1_${game.mode2}`)
    }

    const columns = []
    const columnMap = {
        id: {
            key: 'id',
            dataIndex: 'id',
            title: 'ID',
            render: (id, game) =>
                fold && <a onClick={() => {setGame(game);setExpand(false)}} >{id}</a>
                || <Link onClick={() => {globalData("game", game)}} to={`/match/${id}`}>{id}</Link>
            ,
            align: 'center',
        },
        hero: {
            key: 'hero',
            dataIndex: 'hero',
            title: t('heroListTitle.hero'),
            render: (_, r) => r.playerList.filter(p => p.playerHandle === prop.playerHandle || p.heroId == prop.heroId).map(p => <Icon key={p.heroId} type={'hero'} name={p.heroId} size={30} />)[0],
            align: 'center',
        },
        region: {
            key: 'region',
            dataIndex: 'region',
            title: t('region.region'),
            render: (region) => <Icon type={'region'} name={region} size={24} />,
            align: 'center',
        },
        mode: {
            key: 'mode',
            dataIndex: 'mode',
            title: t('mode.mode'),
            render: (_, r) => GetModeName(r),
            align: 'center',
        },
        duration: {
            key: 'duration',
            dataIndex: 'duration',
            title: t('duration'),
            render: (_, r) => `${Math.floor(r.frame / 16 / 1.4 / 60)}:${fillZero(Math.floor(r.frame / 16 / 1.4) % 60)}`,
            align: 'center',
        },
        team1: {
            key: 'team1',
            dataIndex: 'team1',
            title: t('team') + 1,
            render: (_, r) => {
                return r.playerList.filter(p => p.team === 1).sort((a, b) => a.teamPlace - b.teamPlace).map((p) => <Icon type={'hero'} key={p.heroId} name={p.heroId} size={28} />)
            },
            align: 'center',
        },
        team2: {
            key: 'team2',
            dataIndex: 'team2',
            title: t('team') + 2,
            render: (_, r) => {
                return r.playerList.filter(p => p.team === 2).sort((a, b) => a.teamPlace - b.teamPlace).map((p) => <Icon type={'hero'} key={p.heroId} name={p.heroId} size={28} />)
            },
            align: 'center',
        },
        endTime: {
            key: 'endTime',
            dataIndex: 'endTime',
            title: t('endTime'),
            render: (timeStr) => new Date(Date.parse(timeStr) + timeDiff * 60 * 1000).toLocaleString('chinese',{hour12:false}).replace(" 24:"," 00:"),
            align: 'center',
        },
        kda: {
            key: 'kda',
            dataIndex: 'kda',
            title: t('kda'),
            render: (_, r) => r.playerList.filter(p => p.playerHandle === prop.playerHandle || p.heroId == prop.heroId)
                .sort((a, b) => a.playerHandle === prop.playerHandle ? -1 : 1)
                .map(p => <><span style={{color: "#f5222d"}} >{p.kill}</span><span>/</span><span style={{color: "#1677ff"}} >{p.death}</span><span>/</span><span style={{color: "#ffa940"}} >{p.assist}</span></>)[0],
            align: 'center',
        },
        result: {
            key: 'result',
            dataIndex: 'result',
            title: t('result'),
            render: (_, r) => r.playerList.filter(p => p.playerHandle === prop.playerHandle || p.heroId == prop.heroId)
                .sort((a, b) => a.playerHandle === prop.playerHandle ? -1 : 1)
                .map(p =>
                <div style={{ position: 'relative' }}>
                    {
                         p.win == 0 ? <span style={{color: "black"}} >{t('invalid')}</span> : p.win == 1 ?
                            <span style={{color: "rgb(102, 187, 106)"}} >{t('win')}</span> :
                            <span style={{color: "rgb(255, 76, 76)"}} >{t('lose')}</span>
                    }
                    {
                        p.mvp == 1 ? <Mvp style={{ position: "absolute", top: '-14px', right: '8px'  }}/> : null
                    }
                    {
                        p.mvp == 2 ? <Svp style={{ position: "absolute", top: '-14px', right: '8px'  }}/> : null
                    }
                </div>

            )[0],
            align: 'center',
            width: 70,
        },
        score: {
            key: 'score',
            dataIndex: 'score',
            title: t('score'),
            render: (_, r) => `${r.team1wins}:${r.team2wins}`,
            align: 'center',
        },
    }

    for (const column of prop.columns) {
        columns.push(columnMap[column])
    }


    return expand && <Table size={'middle'} expandable={{
            expandedRowRender: (record) => null,
            rowExpandable: () => true,
            expandRowByClick: true,
            expandIcon: () => null,
            showExpandColumn: false,
            expandedRowKeys: [],
            onExpand: (_, r) => {
                if (fold) {
                    r.fold = 1
                    globalData("game", r)
                    setGame(r)
                    setExpand(false)
                } else {
                    r.fold = 0
                    globalData("game", r)
                    navigate(`/match/${r.id}`)
                }

            }
        }} style={prop.style} columns={columns} pagination={prop.noPage ? false : pageInfo} dataSource={data} loading={loading}/>
    || <Space size={40}>

            <Table expandable={{
                expandedRowRender: (record) => null,
                rowExpandable: () => true,
                expandRowByClick: true,
                expandIcon: () => null,
                showExpandColumn: false,
                expandedRowKeys: [],
                onExpand: (_, r) => {
                    setGame(r)
                }
            }} onRow={(r) =>
                r.id === game.id && {style: {background: "#e6fffb"}} || {}
            } size={'middle'} style={{width: '170px', height: '682px'}} columns={columns2} pagination={prop.noPage ? false : pageInfo} dataSource={data} loading={loading}/>
        <MatchInfo game={game} heroId={prop.heroId} playerHandle={prop.playerHandle} />
    </Space>

}
